import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      'connect':'LogIn',
      Menu:{
        'confSankey': 'Sankey\'s configuration',
        'MEP':'Drawing zone',
        'background':'Background',
        'Noeuds':'Nodes',
        'EN':'Nodes\' tags',
        'EdN':'Editing nodes',
        'flux':'Links',
        'EF':'Links\' tags',
        'EdF':'Editing links',
        'ED':'Data\'s tags',
        'LL':'Text Area',
        'Leg':'Legends',
        'LegX':'Horizontal position',
        'LegY':'Vertical position',
        'LegWidth':'Width',
        'file':'Files',
        'diagramme': 'Diagrams',
        'edition':'Edition',
        'formation':'Tutorials',
        'demo':'Demos',
        'aide':'Help',
        'filter':'Filter',
        'toolbar':'Tools',
        'view':'View',
        'afm':'AFM',
        'excel':'Extract data',
        'ouvrir':'Open',
        'enregistrer':'DL',
        'exporter':'Export',
        'preference':'Setting',
        'reinit':'Reset',
        'pub':'Publish',
        'amp_short':'Layout',
        'amp':'Modify the layout',
        'amp_import':'Import a layout',
        'amp_manuelle':'Modify manualy',
        'esn':'Edit nodes style',
        'esf':'Edit links style',
        'rc':'Keyboard Shortcuts',
        'as':'Additional Help',
        'doc': 'Documentation',
        'ca':'Path',
        'annuler':'Cancel',
        'pdd':'Publish/Update diagram',
        'fmep':'Layout file',
        'ad':'Apply the layout',
        'ns':'Style name',

        'BgC':'Sankey background color',
        'dns':'Display only visible nodes in the nodes selector',
        'dls':'Display only visible links in the links selector',

        'textDisposition':'Apply the modifications on :',
        'PosNoeud':'Nodes\' positions',
        'attrNode':'Nodes\' attributes',
        'attrFlux':'Links\' attributes',
        'tagNode':'Nodes\' tags',
        'tagNode_assign':'Assign a node tag',
        'tagFlux':'Links\' tags',
        'tagFlux_assign':'Assign a link tag',
        'attrGeneral':'Generals attributes',
        'SaveJSON':'Save as JSON',
        'SaveValue':'Save with links\' values',
        'templates':'Templates',
        'warningLimitNode':'Attention : maximum number of nodes reached for not connected user',
        'sankeyPlusDisabled':'Parameter disabled because you don\'t have OpenSankey+',
        'display_scale':'Display link scale',
        'fontSize':'Font size',
        'ajustH':'Adjust. H',
        'ajustV':'Adjust. V',
        'home':'Master',
        'addView':'Add',
        'updateView':'Update',
        'precView':'Prec.',
        'nextView':'Next',
        'check':'Save',
        'style':'Styles',
        'presentation_OS':'OpenSankey is a web application that makes it easy to create Sankey diagrams.\n\n It\'s available free of charge, and includes simple functions for creating nodes, flows and labeling them to aggregate or filter their display on the diagram.\n\n The 15-node limit for use without an account can be lifted by creating a license-free account.\n\n',
        'presentation_OSP':'OpenSankey+ is a paid license that unlocks new features for creating beautiful Sankey diagrams for presentations.\n\nThis license includes advanced formatting features such as the addition of illustrative images or icons for nodes, the addition of color gradients on flows and animations, and more.\n\n But above all, OpenSankey+ lets you generate slideshows to explain your Sankey diagrams, thanks to the "Views" mechanism, which records their visual states (with / without certain filters activated, for example) to simplify navigation between them.\n\n',
        'presentation_OSS':'SankeySuite is a paid license that unlocks all the advanced charting and analysis features of Sankey.\n\n This license includes flow data reconciliation functionalities to identify inconsistencies or calculate flows whose values are not directly accessible.\n\n It also includes OpenSankey+ functionalities.\n\n',

        'rcc_titre_princ':'OpenSankey Application Shortcuts',
        'rcc_titre_select':'With the mouse in selection mode',
        'rcc_cn_bold':'Click (nodes): ',
        'rcc_cn':'Select the clicked node',
        'rcc_ctrl_cn_bold':'CTRL + Click (nodes): ',
        'rcc_ctrl_cn':'Select the clicked node and open the "Nodes" tab of the menu',
        'rcc_cf_bold':'Click (link): ',
        'rcc_cf':'Selects the clicked link',
        'rcc_ctrl_cf_bold':'CTRL + Click (link): ',
        'rcc_ctrl_cf':'Selects the clicked link and opens the "Flow" tab of the menu',
        'rcc_cs_bold':'Click (outside of a node/link): ',
        'rcc_cs':'Deselects the selected nodes and links',
        'rcc_cdn_bold':'Right click (nodes): ',
        'rcc_cdn':'Aggregate the node',
        'rcc_acdn_bold':'Right Alt Click (nodes): ',
        'rcc_acdn':'Desaggregate the knot',
        'rcc_ad_bold':'Alt Drag (label nodes): ',
        'rcc_ad':'Moves the label',
        'rcc_titre_edi':'With the mouse in edit mode',
        'rcc_e_cn_bold':'Click (drawing area): ',
        'rcc_e_cn':'Adds a node where clicked',
        'rcc_e_ds_bold':'Drag (from drawing area): ',
        'rcc_e_ds':'Creates a node at the drag start point and then creates a link from the node created to: either a node already existing if you drop on it, or a node that you create at the place where you drop on the drawing area',
        'rcc_e_dn_bold':'Drag (from a node): ',
        'rcc_e_dn':'Create a link from the drag start node: either a node already existing if you drop on it, or a node that you create where you drop on the drawing area',
        'rcc_titre_autre':'Other shortcuts',
        'rcc_a_s_bold':'Delete: ',
        'rcc_a_s':'Removes selected nodes and links',
        'rcc_a_fc_bold':'Keyboard arrow: ',
        'rcc_a_fc':'Move the selected nodes according to the mesh',
        'rcc_a_dbm_bold':'Drag (middle mouse button and outside a node/link): ',
        'rcc_a_dbm':'Moves the full sankey',
        'rcc_a_ech_bold':'Esc: ',
        'rcc_a_ech':'Closes the Menu when it is open and resets the mouse modeto selection',
        'rcc_titre_OSP':'OpenSankey+ module Shortcuts',
        'rcc_osp_cs_bold':'CTRL+X: ',
        'rcc_osp_cs':'Creates a view which can then be modified. To keep the modifications applied to the view, save it with Ctrl+S.',
        'rcc_osp_ctrl_czdt_bold':'CTRL+Click (Text Box): ',
        'rcc_osp_ctrl_czdt':'Selects the clicked area and opens the text box edit menu',
        'rcc_F7_bold':'F7: ',
        'rcc_F7':'Switche to master data',
        'rcc_F8_bold':'F8: ',
        'rcc_F8':'Switche to previous view',
        'rcc_F9_bold':'F9: ',
        'rcc_F9':'Switch to next view',
        'rcc_ctrl_scrll_bold':'CTRL+scroll (sankey draw zone): ',
        'rcc_ctrl_scrll':'Zoom/Unzoom in the sankey zone',
        'support':'Support',
        'c_support':'Contact the support',
        'rth_support':'We are here to help you',
        'support_explication':'If you encounter a technical problem, write to us at [] and we will deal with your request as quickly as possible.',
        tooltips:{
          noeud:{
            slct: "Choose one / some / all nodes to select via a drop-down list",
            plus: "Add a node, which will be automatically selected.",
            rm: "Allow to delete all currently selected nodes",
            dns: "Display in the node selection list only the nodes that are currently visible in the graphic space"
          },
          flux:{
            slct: "Choose one / some / all link(s) to select via a drop-down list",
            plus: "Add a new link. This one will be automatically selected.",
            rm: "Allow to delete currently selected link(s)",
            dls: "Display in the list of selection of link(s), only the link(s) that is/are currently visible on the graphic space",
          },
          LegX: "Horizontal distance (in px) between the upper left corner of the legend and the upper left corner of the window",
          LegY: "Vertical distance (in px) between the upper left corner of the legend and the upper left corner of the window",
          LegWidth: "Width (in px) for the legend space",
          'PrevViewButton':'Change the view to the previous on in the list',
          'NextViewButton':'Change the view to the next on in the list',
          'saveView':'Save the modification of the view in master data',
          'home':'Return to master data',
          'buttonCreateView':'When working on master data : Create a view / when already on a view: clone the current view ',
          'checkpoint':'Save the data in the browser to not lost it when you leave the application',
          'fontSize':'Change the size of the font in the legend'
        }
      },
      MEP:{
        'onBlur':'Value is applied when we leave the input',
        'Echelle':'Scale of diagram',
        'MaxFlux':'Maximal thickness for links (px)',
        'MinFlux':'Minimum thickness for links (px)',
        'vp100':'value for 100px',
        'TCG':'Background grid',
        'AN':'Arrange the nodes on the grid',
        'Horizontal':'Horizontal spacing between nodes',
        'Vertical':'Vertical spacing between nodes',
        'PA':'Automatic positioning of nodes and links',
        'PA_action':'Position',
        'factExpH':'Horizontal expansion factor',
        'factExpV':'Vertical expansion factor',
        'stretchH':'Apply',
        'stretchV':'Apply',
        tooltips: {
          Echelle: "Change the scale of the links and nodes",
          MaxFlux: "Change the maximum size (in pixels) for the display of the links",
          MinFlux: "Change the minimum size (in pixels) for the display of the links",
          TCG: "Size of the background grid tiles (in pixels)",
          GV: "Enable or disable the display of the background grid",
          AN: "Automatically arrange nodes: ie come and paste the upper left corner of the nodes on the nearest grid corner",
          EEN_h: "Default horizontal distance (in pixel) between nodes for automatic positioning",
          EEN_v: "Default vertical distance (in pixel) between nodes for automatic positioning",
          PA: "Perform an automatic positioning of the nodes according to the specified default distances",
          BgC: "Change the background color of the interactive graphic space",
          'factExpH':'Modifies the horizontal expansion factor: the application of the factor multplie the horizontal deviation of each node from the leftmost by the input factor',
          'factExpV':'Modifies the vertical expansion factor: the application of the factor multplie the vertical deviation of each node from the highest by the input factor',

        }
      },
      Tags:{
        'Nom':'Name',
        'Leg':'Legend',
        'tags':'Tags',
        'Bannière':'Banner',
        'Position':'Position',
        'Aucun':'None',
        'Unique':'Unique',
        'Multiple':'Multiple',
        'Niveau' : 'Level',
        'Visible':'Visible',
        'Couleur':'Color',
        'Forme':'Shape',
        'GE':'Tags\' Group',
        'selct':'Selected',
        tooltips: {
          pal: "Apply a random color palette for the tags of the selected group",
          pal_shuffle: "Change the order of the colors applied to the tags of the selected group",
          pal_std: "Choose a standard color palette for the tags of the selected group",
          add: "Add a tag to the selected group",
          add_grp: "Add a tag group",
          rm: "Delete the tag",
          rm_grp: "Delete this tag group",
          nom: "Rename the current tag",
          nom_grp: "Rename this tag group",
          leg_grp: "Activate or not the legend on the filtering of this group of tags and therefore the colors associated with the tags of this group",
          visible: "Choose to make visible or not the nodes associated with this tag",
          couleur: "Change the color of the current tag",
          forme: "Choose the shape of the nodes associated with this tag",
          banner: "Choose the type of dropdown menu on the filtering of this tag group (None / Single / Multiple / LevelTags)",
          up: "Move the tag group up in the node filtering menu",
          down: "Move the tag group down in the node filter menu"
        }
      },
      Noeud:{
        'Nom':'Name',
        'Style':'Style',
        'SelectStyle':'Select a style',

        'AS':'Apply the style',
        'TS':'Select all',
        'plns':'Parameter for selected nodes',
        'NS':'No node selected',
        'Reorg':'Reorganize incoming/outgoing links',
        'SlctOutLink':'Select outgoing links',
        'SlctInLink':'Select incoming links',
        'IB':'Tooltip',
        'align_horiz': 'Align nodes horizontally',
        'align_horiz_min':'Relative to the selected node furthest to the left',
        'align_horiz_max': 'Relative to the selected node furthest to the right',
        'align_vert': 'Align nodes vertically',
        'align_vert_min': 'Relative to the selected topmost node',
        'align_vert_max': 'Relative to the selected node furthest down',
        tooltips:{
          Nom: "Change the name of the selected node. If several nodes are selected, this field is disabled",
          AS: "Allow to apply a predefined style in the preference menu to the selected node(s)",
          Reorg:"Allows automatic reorganization of incoming and outgoing flows (up/down position)",
          SlctOutLink:"Allow to select all outgoing flows from the node(s)",
          SlctInLink:"Allow to select all incoming flows to the node(s)",
          IB: "Tooltip : text formatted in html and displayed with the tooltip of the node. This tooltip pops on graphic space with SHIFT + MOUSE on the node."
        },
        apparence:{
          'apparence':'Appearence',
          'Visibilité':'Visibility',
          'Couleur':'Color',
          'CouleurPérenne':'Static color',
          'Forme':'Shape',
          'Cercle':'Circle',
          'Rectangle':'Rectangle',
          'TML':'Minimum width',
          'TMH': 'Minimum height',
          'HideAlone':'Hide if node is intermediate',
          'asn':'Apply style to nodes',
          'toScale':'Node out of scale',
          'Orientation':'Orientation : ',
          'toScaleBottom':'to the bottom',
          'toScaleTop':'to the top',
          'toScaleLeft':'to the left',
          'toScaleRight':'to the right',
          'raw':'Raw editor',

          tooltips: {
            Visibilité: "Makes the selected node(s) visible or invisible",
            Couleur: "Choose the color of the selected node(s)",
            CouleurPérenne: "Keep the color of the node(s) if any filter is activated",
            Forme: "Choose a shape between rectangle or circle for the selected node(s)",
            TML: "Minimum width in pixels of the selected node(s)",
            TMH: "Minimum height in pixels of the selected node(s)"
          }
        },
        labels:{
          'labels':'Labels',
          'vdb':'Label visibility',
          'lb':'White label',
          'pv':'Vertical position',
          'pos':'Position',
          'pos_v':'Value position',
          'top':'Top',
          'middle':'Middle',
          'bottom':'Bottom',
          'ph':'Horizontal position',
          'left':'Left',
          'right':'Right',
          'tp':'Font size',
          'police':'Font type',
          'gras':'Bold',
          'maj':'Uppercase',
          'ita':'Italic',
          'cl':'Text box width',
          'vdv':'Set value visibility',
          tooltips: {
            vdb: "Displays or not the label(s) attached to the selected node(s)",
            lb: "Displays the text of the label(s) in white or black (useful if label is positioned on node(s))",
            top: "Displays the label(s) above the selected node(s)",
            Milieu_pv: "Displays the label(s) in the middle (vertically) of the selected node(s)",
            Bas: "Displays the label(s) below the selected node(s)",
            gauche: "Displays the label(s) to the left of the selected node(s)",
            Milieu_ph: "Displays the label(s) in the middle (horizontally) of the selected node(s)",
            droite: "Displays the label(s) to the right of the selected node(s)",
            cl: "Width of the text area (in pixels) for the label(s) of the selected node(s)",
            vdv: "Displays or not the associated value with the selected node(s)",
            haut_val: "Displays the associated value above the selected node(s)",
            Milieu_pv_val: "Displays the associated value in the middle (vertically) of the selected node(s)",
            Bas_val: "Displays the associated value below the selected node(s)",
            gauche_val: "Displays the associated value to the left of the selected node(s)",
            Milieu_ph_val: "Displays the associated value in the middle (horizontally) of the selected node(s)",
            droite_val: "Displays the associated value to the right of the selected node(s)",
          }
        },
        icon:{
          'icon':'Icon',
          'si':'Select icon',
          'couleur':'Color',
          'rIN':'Size ratio icon/node',
          'Aucun':'None'
        },
        FO:{
          'FO':'Foreign Object',
          'content':'Content',
        },
        tags_node:{
          'tags':'Tags',
          'Appartenance':'Affiliations'
        },
        agre:{
          'Agré':'Aggregation',
          'DC':'Cube\'s dimensions',
          'Parent':'Parent',
          'CLE':'Copy childs\' links'
        },
        PF:{
          'PF':'I/O links positions',
          'PFM':'I/O links positions',
          'FES':'Links type',
          'ent':'Input',
          'sort':'Output',
          'FRN':'Relative position to the node',
          'gauche':'Left',
          'droite':'Right',
          'ades':'Above',
          'edes':'Below',
          'lti':'Identify the links in the table with their colors',
          'col':'Apply',
          tooltips:{
            ent: "Display in the table below, the incoming links of the selected node(s)",
            sort: "Display in the table below, the outgoing links of the selected node(s)",
            droite: "Display in the table below, the links on the right of the selected node(s)",
            gauche: "Display in the table below, the links on the left of the selected node(s)",
            ades: "Display in the table below, the feeds above the selected node(s)",
            edes: "Display in the table below, the feeds below the selected node(s)",
            lti: "Display the lines of the links table with their respective colors to better identify them"
          }
        }
      },
      Flux:{
        'pg': 'General settings',
        'pdl':'Font',
        'pl': 'Parameters per link',
        'src':'Source',
        'trgt':'Target',
        'if':'Reverse direction',
        'dzf':'Relative overlay on display',
        'style':'Style',
        'as':'Apply the style to selected link(s)',
        'asf':'Apply style to links having this style',
        'IB':'ToolTip',
        tooltips: {
          src: "Choice of the departure node for the selected link(s)",
          trgt: "Choice of the arrival node for the selected link(s)",
          if: "Reverse the start and finish nodes for the selected link(s)",
          up: "Move up one step to the foreground",
          upup: "Put the selected link(s) in the foreground",
          dwn: "Go down one step to the last plane",
          dwndwn: "Move the selected link(s) to the last plane",
          as: "Allow to apply a predefined style in the preference menu to the selected node(s)",
          IB: "Tooltip : text formatted in HTML and displayed with the tooltip of the link. This tooltip pops on graphic space with SHIFT + MOUSE on the link."
        },
        data:{
          'données':'Data',
          'vpp':'Value for given parameters',
          'affichage':'Display',
          'toPrecision':'Display the value in scientific notation',
          tooltips: {
            vpp: "Data associated to the selected link and, if existing, for the selected tag(s)",
            toPrecision: "Activate or not the notation in scientific format, for the display of the link's data on the Sankey diagram",
            affichage: "Replacement text for the display of the link's data on the Sankey diagram"
          }
        },
        apparence:{
          'apparence':'Appearance',
          'couleur':'Color',
          'grad':'Gradient',
          'hach':'Dashed',
          'of':'Orientation',
          'pdc':'Position of the center point (%)',
          'eep':'Position of the centers of curvature (%)',
          'type':'Type',
          'courbe':'Curve',
          'fleche':'Arrow',
          'recy':'Recycling',
          'courbure':'Curvature',
          'opacity':'Opacité',
          'arrow_size':'Size of arrow',
          tooltips: {
            couleur: 'Choose the color for the selected link(s)',
            grad: 'Apply a gradient color effect on the selected link(s). The gradient is done between the color of the start node and the color of the end node',
            hach: 'Applies a hatch effect on the selected link(s)',
            of_vv: 'Allows to orient the beginning of the link vertically and the end of the link vertically',
            of_hh: 'Allows to orient the beginning of the link horizontally and the end of the link horizontally',
            of_hv: 'Allows to orient the beginning of the link horizontally and the end of the link vertically',
            of_vh: 'Allows to orient the beginning of the link vertically and the end of the link horizontally',
            pdc: 'Allows to refine the position of the center of the selected link(s). This value is a ratio (%) relative to the starting point of the link',
            eep: 'Allows to refine the positions of the centers of curvature of the selected link(s). This value is a ratio (%) relative to the center point of the link. These centers of curvature are mirrored with respect to the center of the link(s)',
            courbe: 'Represents the selected link(s) as a Bezier curve',
            fleche: 'Represents the selected link(s) with an arrow tip at the end',
            recy: 'Represents the selected link(s) as a recycle, i.e. with a backward turn',
            courbure: 'Setting the radius of curvature in case the selected link(s) are represented as Bezier curve(s)',
            arrow_size:'Change the size of the arrow (from the end of the link to the node)'
          }
        },
        label:{
          'label':'Label',
          'vdb':'Label visibility',
          'len':'Black label',
          'lb':'White label',
          'lec':'Colored label',
          'acf':'Orient along the link axis',
          'pl':'Lateral position',
          'po':'Orthogonal position',
          'milieu': 'Middle',
          'deb':'Start',
          'fin':'End',
          'dessous':'Above',
          'dessus':'Below',
          'pls':'Position the label with the mouse',
          'toPrecision':'Display the value in scientific notation',
          'NbPrecision':'Number of significant figures',
          tooltips: {
            label: "Display or not the label (data / text) associated to the selected link(s)",
            len: "Display the label in black, for the selected link(s)",
            lb: "Display the label in white, for the selected link(s)",
            lec: "Display the label with the same color(s) as the one(s) associated with the selected link(s)",
            acf: "For the selected link(s), allows to orient the label following the shape of the associated link",
            deb: "For the selected link(s), allows to position the label towards the starting point of the link",
            milieu_h: "For the selected link(s), allows to position the label between the starting point and the end point of the link",
            end: "For the selected link(s), allows to position the label towards the end point of the link",
            below: "For the selected link(s), allows to position the label below the link",
            milieu_v: "For the selected link(s), allows to position the label inside the link",
            top: "For the selected link(s), allows to position the label above the link",
            pls: "Activates the possibility to move the label of the selected link(s) with the mouse",
            toPrecision: 'Activate or not the notation in scientific format, for the display of the link\'s data on the Sankey diagram',
            NbPrecision:'Choose the number of significant figures when the value is diplayed in scientific notation',

          }
        },
        'layout':'Disposition',
        'layoutUp':'Move forward',
        'layoutTop':'Move to the top',
        'layoutDown':'Move backward',
        'layoutBottom':'Move to the bottom',
      },
      LL:{
        'hl':'Text Area Height',
        'll':'Text Area Width',
        'ft':'Background opacity',
        'cfl':'Background Color',
        'bt':'Transparent border',
        'cbl':'Border Color',
        'pvt':'Vertical position',
        'at':'Texte alignment',
        'labels':'Labels',
        'gras':'Bold',
        'maj':'Uppercase',
        'ita':'Italic',
        'centre':'Centre',
        'textAsHTML':'foreignObject text area',
        'editorRaw':'Editeur brut'
      },
      Banner:{
        'data':'Data',
        'fdf':'Link filtering',
        'fdn':'Node Filtering',
        'ndd':'Levels of detail',
        'ndd_lst':'Tags groups',
        'ndd_chk':'Apply the groups\' colors',
        'sdr':'Diagram type',
        'sdd':'Data selection',
        'tl':'Download',
        'rslt': 'Download results',
        'p_aff':'Display settings',
        'p_aff_aff_links':'Links display settings',
        'p_aff_aff_node':'Nodes display settings',
        'p_aff_filtre_links':'Links display filter',
        'filtre':'Threshold value for links dislay',
        'fl':'Threshold value for labels display',
        'fn':'Null Link',
        'visible':'Visible',
        'hlp':'Help',
        'hlp_1':'Sankey diagram',
        'hlp_1_txt_1':'In a sankey diagram the thickness of an arrow is proportional to the value of the flux it represents.',
        'hlp_1_txt_2':'The diagram can be viewed with different levels of aggregation using the Level of Detail> selector',
        'hlp_1_txt_3':'Filters can be used to display only parts of the diagram. To do this use the selectors',
        'hlp_1_txt_4':'Different color palettes can be used to color nodes and flows using the Color Palette selector',
        'hlp_1_txt_5':'The diagram structure (without link thickness) can be displayed by checking Diagram structure',
        'hlp_1_txt_6':'The diagram can be adjusted on screen by checking Adjust on screen',
        'hlp_1_txt_7':'To get information about each link, press shift and move the mouse over the link',
        'hlp_1_txt_8':'Setting setting some visual parameters for the elements of the sankey ',
        'hlp_1_txt_9':'Dropdown to filter node/link/data according to their group tag or to choose to display the diagram with color palette from a tag group.',
        'tooltipAdjust':'Readjust the drawing area to the screen size',
        'tooltipStructure':'Allows to display the structure of the diagram without proportion of the flows according to their value',
        'tooltipData':'Allows to display the data of the diagram',
        'tooltipSelection':'Allows to drag the nodes',
        'tooltipHelp':'Show the help dialog',
        'tooltipAjoutNode':'Adds a node to the mouse click',
        'tooltipLiason':'Allows to create links between two existing nodes, from an existing node or to an existing node'
      },
      Login:{
        'con':'Login',
        'dec':'Log off',
        'con_win':'Connect to the application',
        'err_appel_serveur':'An error occurred when calling the server',
        'err_login':'Error, your email or password is incorrect, please check your login information and try again'
      },
      Register:{
        'reg_win':'Create an account',
        'OS+_lic': 'OpenSankey+ License Number (Optional)',
        'OS+_link':'Discover OpenSankey+',
        'SS_lic': 'SankeySuite License Number (Optional)',
        'SS_link':'Discover SankeySuite',
        'reg': 'Sign up'
      },
      UserPages:{
        'to_app':'Back to the application',
        'to_con':'Sign in',
        'to_reg':'Sign up',
        'to_acc':'My account',
        'to_dbd':'Dashboard',
        'id': 'Username',
        'mdp': 'Password',
        'pnom': 'Firstname',
        'nom': 'Name',
        'OS+_lic': 'OpenSankey+ license',
        'SS_lic': 'SankeySuite license',
        'update_lic': 'Register new license number',
        'win_acc_infos': 'Account details',
        'win_db_template': 'Availables templates',
        'db_desc_template': 'Template description',
        'usr_no_lic': 'No license currently registered',
        'usr_lic_validdate': 'Date of validity : ',
        'usr_lic_expdate': 'Expired on : ',
        'usr_lic_valid': 'Valid license',
        'usr_lic_invalid': 'Invalid license',
        'usr_lic_deactivated': 'License deactivated',
        'usr_lic_err': 'License number invalid',
        'err_get_user_infos':'Error while trying to access the user\'s infos',
        'err_get_OS+_infos': 'Error while trying to access the OpenSankey+ license server',
        'err_get_SS_infos': 'Error while trying to access the SankeySuite license server'
      },
      view:{
        'select':'Select View',
        'actual':'Sankey master',
        'name':'Name',
        'delete':'Delete',
        'copy':'Clone',
        'import':'Import',
        'export':'Export',
        'applyDisplayFromView':'Apply the layout from another view',
        'ns':'View not saved',
        'warn_ns':'You are about to change your view before saving the current view, do you want to save the changes before changing your view ?',
        'dont_save':'No',
        'save':'Yes',
        'exportAll':'Export all view',
        'importMultiple':'Import multiple views',

      },
      welcome:{
        'welcome':'Welcome to OpenSankey web application',
        'read_me':'Read me',
        'intro':'Introduction',
        'rc':'Keyboard Shortcut',
        'licence':'Licences',
        'news':'Updates',
        'exemple1':'Exemple of a sankey diagram with gradient links (functionality from Opensankey+) ',
        'exemple2':'Exemple of a sankey diagram realised with Opensankey',
        1: 'Mouse mode selection button, there are 2 modes: a mode to select nodes and flows to be able to move them, then a mode to create links and nodes with mouse click',
        2: 'Buttons to filter the visibility or colors of nodes and flows according to the groups to which they are associated',
        3: 'Buttons to filter the nodes according to their aggregation level',
        4: 'Buttons to filter the visibility of the flows according to their values, this button also allows to modify the scale of the diagram (the thickness of the flows)',
        5: 'Buttons to adjust the size of the drawing area so that all elements are visible',
        6: 'Buttons to display the diagram without taking into account the value of the flows',
        7: 'Buttons to display additional help',
        8: 'Navigation menu to open,save, edit sankeys',
        9: 'Buttons to connect with an opensankey account and enable additional modules',
        10:'Buttons to open the configuration menu to edit the elements of the sankey diagram' ,
        'view':'Buttons to navigate through the differents views of the sankey',
        'excel':'Button download the data used for the sankey in Excel format',
        'news_content': {
          230803: {
            'main_title': 'August 03, 2023: New features',
            'main_content': 'We added new features to make it easier to manipulate Sankey diagrams',
            'sub_title_1': 'Right-click with a lot of options',
            'sub_content_1': 'From now on, a lot of actions on nodes, links and even drawing areas are accessible by right-clicking on the concerned elements.',
            'sub_title_2': 'Multiple selection frame',
            'sub_content_2': 'Multiple selection of nodes can now be made with selection frames.',
            'sub_title_3': 'Ease the expansion of your diagrams',
            'sub_content_3': 'The drawing area can be expanded in any direction by dragging nodes/flows/text boxes/captions in the chosen direction.',
            'image1': 'clic droit noeud EN.PNG',
            'image2': 'clic droit flux EN.PNG',
            'image3': 'clic droit fond EN.PNG',
            'image4': 'Zone de selection.PNG'
          }
        }
      },
      'useTemplate':'Use this template',
      'dl':'Download excel',
      'useTutoJSON':'Open file',
      'useTutoExcel':'Open file (Excel)',
      'menuTuto':'Open tutorials menu',

      'DisplayWelcome':'Display welcome',
      'dontSeeAgain':'Don\'t show again',
      'elements_sankey+_blocked':'Blocked diagram elements (OpenSankey+)',
      'mfa_blocked':'Blocked diagram elements (MFASankey)',
      'elements_sankey+_blocked_long':'Some Sankey elements are not visible because they come from OpenSankey+ and your account does not have this module',
      'elements_mfa_blocked_long':'Some Sankey elements are not visible because they come from MFASankey and your account does not have this module',
      'scale':'Scale',
      'desire_to_know_more':'About',
      'legal':'Legal information',
      'tdr':'All right reserved',
      'fullscreen':'Activate fullscreen',
      'exitFullscreen':'Exit fullscreen',


    }
  },
  //=======================================================
  //FR
  //=======================================================
  fr: {
    translation: {
      'connect':'Connexion',
      Menu:{
        'confSankey': 'Configuration du Sankey',
        'diagramme' : 'Diagrammes',
        'MEP':'Zone de dessin',
        'background':'Arrière plan',
        'Noeuds':'Noeuds',
        'EN':'Étiquettes des noeuds',
        'EdN':'Édition des noeuds',
        'flux':'Flux',
        'EF':'Étiquettes des flux',
        'EdF':'Édition des flux',
        'ED':'Étiquettes des données',
        'LL':'Zone de Texte',
        'Leg':'Legendes',
        'LegX':'Position horizontale',
        'LegY':'Position verticale',
        'LegWidth':'Largeur',
        'file':'Fichiers',
        'edition':'Édition',
        'formation':'Tutoriels',
        'demo':'Démos',
        'aide':'Aide',
        'filter':'Filtres',
        'toolbar':'Outils',
        'view':'Vues',
        'afm':'AFM',
        'excel':'Extraire données',
        'ouvrir':'Ouvrir',
        'enregistrer':'Téléch.',
        'exporter':'Exporter',
        'preference':'Réglage',
        'reinit':'Réinit.',
        'pub':'Publier',
        'amp_short':'M.e.p',
        'amp':'Modifier la mise en page',
        'amp_import':'Importer une mise en page',
        'amp_manuelle':'Modifier manuellement',
        'esn':'Editer le style des noeuds',
        'esf':'Editer le style des flux',
        'rc':'Raccourcis clavier',
        'as':'Aide Supplémentaire',
        'doc': 'Documentation',
        'ca':'Chemin d\'accés',
        'annuler':'Annuler',
        'pdd':'Publier/Mettre à jour le diagramme',
        'fmep':'Fichier de mise en page',
        'ad':'Appliquer la mise en page',

        'ns':'Nom du Style',

        'BgC':'Couleur du fond de page',
        'dns':'N\'affiche que les noeuds visibles dans le sélecteur de noeuds',
        'dls':'N\'affiche que les flux visibles dans le sélecteur de flux',

        'textDisposition':'Appliquer les modifications sur :',
        'PosNoeud':'Positions des noeuds',
        'attrNode':'Attributs des noeuds',
        'attrFlux':'Attributs des flux',
        'tagNode':'Etiquettes des noeuds',
        'tagNode_assign':'Assigner une étiquettes',
        'tagFlux':'Etiquettes des flux',
        'tagFlux_assign':'Assigner une étiquettes',
        'attrGeneral':'Attributs généraux',
        'SaveJSON':'Enregistrer JSON',
        'SaveValue':'Enregistrer avec les valeurs des flux',
        'templates':'Modèles',
        'warningLimitNode':'Attention :Nombre de noeuds limite atteint pour les utilisateurs non connecté',
        'sankeyPlusDisabled':'Paramètre désactivé car vous n\'avez pas OpenSankey+',
        'display_scale':'Afficher l\'échelle',
        'fontSize':'Taille police',
        'ajustH':'Ajust. H',
        'ajustV':'Ajust. V',
        'home':'Maître',
        'addView':'Ajout',
        'updateView':'M-à-j',
        'precView':'Préc.',
        'nextView':'Suiv.',
        'check':'Sauv.',
        'style':'Styles',
        'presentation_OS':'OpenSankey et une application web qui permet de réaliser simplement des diagrammes de Sankey.\n\nCelle-ci est accessible gratuitement, et inclut les fonctionnalités simples de création de nœuds, de flux et leur étiquetage afin d\'agréger ou de filtrer leur affichage sur le diagramme.\n\n La création d\'un compte sans licence permet de lever la limitation de 15 nœuds fixée pour un usage sans compte.\n\n',
        'presentation_OSP':'OpenSankey+ est une licence payante qui permet de débloquer de nouvelles fonctionnalités pour la réalisation de beaux diagrammes de Sankey pour des présentations.\n\n Cette licence inclut des fonctionnalités de mise en forme avancées comme l\'ajout d\'images ou d\'icônes illustratifs pour les noeuds, l\'ajout de gradients de couleurs sur les flux et d\'animations, etc.\n\n Mais surtout, OpenSankey+ permet de générer des diaporamas explicatifs de vos diagrammes de Sankey grâce au mécanisme des "Vues", qui enregistre les états visuel de celui-ci (avec / sans certains filtres activés par exemple) pour simplifier la navigation entre eux.\n\n',
        'presentation_OSS':'SankeySuite est une licence payante qui permet de débloquer toutes les usages avancés de réalisation et d\'analyse des diagrammes de Sankey.\n\nCette licence inclut les fonctionnalités de réconciliation des données de flux afin de relever des incohérences ou de calculer des flux dont les valeurs ne sont pas accessibles directement.\n\n Elle inclut aussi les fonctionnalités de OpenSankey+.\n\n',

        'rcc_titre_princ':'Raccourcis de l\'application OpenSankey',
        'rcc_titre_select':'Avec la souris en mode sélection',
        'rcc_cn_bold':'Click (noeuds) :',
        'rcc_cn':'Sélectionne le noeud cliqué',
        'rcc_ctrl_cn_bold':'CTRL + Click (noeuds) :',
        'rcc_ctrl_cn':'Sélectionne le noeud cliqué et ouvre l\'onglet "Noeuds" du menu',
        'rcc_cf_bold':'Click (flux) :',
        'rcc_cf':'Sélectionne le flux cliqué',
        'rcc_ctrl_cf_bold':'CTRL + Click (flux) :',
        'rcc_ctrl_cf':'Sélectionne le flux cliqué et ouvre l\'onglet "Flux" du menu',
        'rcc_cs_bold':'Click (en dehors d\'un noeud/flux) : ',
        'rcc_cs':'Désélectionne les noeuds et flux sélectionnés',
        'rcc_cdn_bold':'Click droit (noeuds) :',
        'rcc_cdn':' Agrège le noeud',
        'rcc_acdn_bold':'Alt Click droit (noeuds) :',
        'rcc_acdn':' Désagrège le noeud',
        'rcc_ad_bold':'Alt Drag (label noeuds) :' ,
        'rcc_ad':'Déplace le label' ,
        'rcc_titre_edi':'Avec la souris en mode édition',
        'rcc_e_cn_bold':'Click (zone de dessin) :',
        'rcc_e_cn':'Ajoute un noeud à l\'endroit cliqué',
        'rcc_e_ds_bold':'Drag (à partir de la zone de dessin) :',
        'rcc_e_ds':'Crée un noeud au point de départ du drag puis crée un flux à partir du noeud crée vers : soit un noeud déjà existant si l\'on drop dessus, soit un noeud que l\'on crée à l\'endroit où l\'on drop sur la zone de dessin',
        'rcc_e_dn_bold':'Drag (à partir d\'un noeud) :',
        'rcc_e_dn':'Créer un flux à partir du noeud de départ du drag vers : soit un noeud déjà existant si l\'on drop dessus, soit un noeud que l\'on crée à l\'endroit où l\'on drop sur la zone de dessin',
        'rcc_titre_autre':'Autres raccourcis',
        'rcc_a_s_bold':'Suppr :',
        'rcc_a_s':'Supprime les noeuds et flux sélectionnés',
        'rcc_a_fc_bold':'Flèche du clavier :',
        'rcc_a_fc':'Permet de déplacer les noeuds sélectionnés en fonction du grillage',
        'rcc_a_dbm_bold':'Drag (bouton du milieu de la souris et en dehors d\'un noeud/flux):',
        'rcc_a_dbm':' Permet de déplacer le sankey complet',
        'rcc_a_ech_bold':'Echap :',
        'rcc_a_ech':'Ferme le Menu quand il est ouvert et remet la fonction de la souris en tant que sélecteur',
        'rcc_titre_OSP':'Raccourcis du module OpenSankey+',
        'rcc_osp_cs_bold':'CTRL+X :',
        'rcc_osp_cs':'Crée une vue qui peut être ensuite modifié, pour conserver les modifications appliquées à la vue il faut l\'enregistrer avec Ctrl+S',
        'rcc_osp_ctrl_czdt_bold':'CTRL+Click (Zone Texte) :',
        'rcc_osp_ctrl_czdt':'Sélectionne la zone clické et ouvre le menu d\'édition de zone de texte',
        'rcc_F7_bold':'F7: ',
        'rcc_F7':'Retourne aux données maîtres',
        'rcc_F8_bold':'F8: ',
        'rcc_F8':'Passe à la vue précédente',
        'rcc_F9_bold':'F9: ',
        'rcc_F9':'Passe à la vue suivante',
        'rcc_ctrl_scrll_bold':'CTRL+scroll (zone de dessin): ',
        'rcc_ctrl_scrll':'Permet de zoomer/dezomer sur la zone de dessin',
        'support':'Support',
        'c_support':'Contacter le support',
        'rth_support':'Nous sommes là pour vous aidez',
        'support_explication':'Si vous rencontrez un problème technique, écrivez-nous à [], nous traiterons votre demande dans les meilleurs délais.',
        tooltips:{
          noeud:{
            slct: "Choisir un / des / tous les noeud(s) à sélectionner via une liste déroulante",
            plus: "Ajouter un noeud. Celui-ci sera automatiquement selectionné.",
            rm: "Permettre de supprimer tous les noeud(s) actuellement sélectionné(s)",
            dns: "Afficher dans la liste de selection des noeuds, uniquement ceux actuellement visibles sur l'espace graphique"
          },
          flux:{
            slct: "Choisir un / des / tous les flux à sélectionner via une liste déroulante",
            plus: "Ajouter un flux. Celui-ci sera automatiquement selectionné.",
            rm: "Permettre de supprimer tous les flux actuellement sélectionné(s)",
            dls: "Afficher dans la liste de selection des flux, uniquement ceux actuellement visibles sur l'espace graphique",
          },
          LegX: "Ecart horizontal (en px) entre le coin supérieur gauche de la légende par rapport au coin supérieur gauche de la fenêtre",
          LegY: "Ecart vertical (en px) entre le coin supérieur gauche de la légende par rapport au coin supérieur gauche de la fenêtre",
          LegWidth: "Largeur (en px) de l'espace de la légende",
          'PrevViewButton':'Charge la vue précédente',
          'NextViewButton':'Charge la vue suivante',
          'saveView':'Enregistre les modifications apportées à la vue',
          'home':'Retourne aux données maître',
          'buttonCreateView':'Sur les données maîtres: crée une vue / sur une vue: clone la vue',
          'checkpoint':'Enregistre les données dans le navigateur pour ne pas les perdre quand vous quittez l\'application',
          'fontSize':'Modilie la taille de la font dans la légende'

        }
      },
      MEP:{
        'onBlur':'La valeur sera appliquée dès que l\'on quitte l\'input',
        'Echelle': 'Echelle du diagramme',
        'MaxFlux': 'Taille maximale des flux (px)',
        'MinFlux': 'Taille minimale des flux (px)',
        'vp100':'valeur pour 100px',
        'TCG':'Quadrillage en fond',
        'AN':'Arranger les noeuds sur le quadrillage',
        'Horizontal':'Ecartement horizontal des noeuds',
        'Vertical':'Ecartement vertical des noeuds',
        'PA':'Positionnement automatique des noeuds et flux',
        'PA_action':'Positioner',
        'factExpH':'Facteur d\'expansion horizontale',
        'factExpV':'Facteur d\'expansion verticale',
        'stretchH':'Appliquer',
        'stretchV':'Appliquer',
        tooltips: {
          Echelle: "Modifier l'échelle des flux et noeuds",
          MaxFlux: "Modifier la taille maximale (en pixel) pour l'affichage des flux",
          MinFlux: "Modifier la taille minimale (en pixel) pour l'affichage des flux",
          TCG: "Taille des carreaux de la grille de fond (en pixel)",
          GV: "Activer ou désactiver l'affichage de la grille de fond",
          AN: "Arrangement automatiquement les noeuds : ie venir coller le coin supérieur gauche des noeuds sur le coin de grille le plus proche",
          EEN_h: "Ecart horizontal par défaut (en pixel) entre les noeuds pour un positionnement automatique",
          EEN_v: "Ecart vertical par défaut (en pixel) entre les noeuds pour un positionnement automatique",
          PA: "Réaliser un positionnement automatique des noeuds en fonction des écarts par défaut spécifiés",
          BgC: "Changer la couleur fond de l'espace graphique interactif",
          'factExpH':'Modifie le facteur d\'expansion horizontale : l\'application du facteur multplie l\'écart horizontale de chaque noeuds par rapport à celui le plus à gauche par le facteur de l\'input',
          'factExpV':'Modifie le facteur d\'expansion verticale : l\'application du facteur multplie l\'écart verticale de chaque noeuds par rapport à celui le plus haut par le facteur de l\'input',
        }
      },
      Tags:{
        'Nom':'Nom',
        'Leg':'Légende',
        'tags':'Étiquette',
        'Bannière':'Bannière',
        'Position':'Position',
        'Aucun':'Aucun',
        'Unique':'Unique',
        'Multiple':'Multiple',
        'Niveau': 'Niveau',
        'Visible':'Visible',
        'Couleur':'Couleur',
        'Forme':'Forme',
        'GE':'Groupe d\'étiquettes',
        'selct':'Sélectionné',
        tooltips: {
          pal: "Appliquer une palette de couleurs aléatoires pour les étiquettes du groupe sélectionné",
          pal_shuffle: "Changer l'ordre des couleur appliquées aux étiquettes du groupe sélectionné",
          pal_std: "Choisir une palette de couleurs standard pour les étiquettes du groupe sélectionné",
          add: "Ajouter une étiquette au groupe sélectionné",
          add_grp: "Ajouter un groupe d'étiquette",
          rm: "Supprimer l'étiquette",
          rm_grp: "Supprimer ce groupe d'étiquette",
          nom: "Renommer l'étiquette courante",
          nom_grp: "Renommer ce groupe d'étiquette",
          leg_grp: " Active ou non la légende sur le filtrage de ce groupe d'étiquettes et donc les couleurs associées aux étiquettes de ce groupe",
          visible: "Choisir de rendre visible ou non les noeuds associés à cette étiquette",
          couleur: "Changer la couleur de l'étiquette courante",
          forme: "Choisir la forme des noeuds associés à cette étiquette",
          banner: "Choisir le type de menu déroulant sur le filtrage de ce groupe d'étiquettes (Aucun / Unique / multiple / LevelTags)",
          up: "Monter le groupe d'étiquettes dans le menu de filtrage des noeuds",
          down: "Descendre le groupe d'étiquettes dans le menu de filtrage des noeuds"
        }
      },
      Noeud:{
        'Nom':'Nom',
        'Style':'Style',
        'SelectStyle':'Selectionner un style',
        'AS':'Appliquer le style',
        'plns':'Paramètres pour les noeuds sélectionnés',
        'TS':'Tout sélectionner',
        'NS':'Aucun noeud sélectionné',
        'Reorg':'Réorganisation automatique flux E/S',
        'SlctOutLink':'Sélectionner flux sortants',
        'SlctInLink':'Sélectionner flux entrants',
        'IB':'Info-bulle',
        'align_horiz':'Aligner les noeuds horizontalement',
        'align_horiz_min':'Par rapport au noeud séléctionné le + à gauche',
        'align_horiz_max':'Par rapport au noeud séléctionné le + à droite',
        'align_vert':'Aligner les noeuds verticalement',
        'align_vert_min':'Par rapport au noeud séléctionné le + en haut',
        'align_vert_max':'Par rapport au noeud séléctionné le + en bas',
        tooltips:{
          Nom: "Changer le nom du noeud sélectionné. Si plusieurs noeuds sont sélectionnés, ce champ est désactivé",
          AS: "Permettre d'appliquer un style prédéfini dans le menu préférence au(x) noeud(s) selectionné(s)",
          Reorg:"Permet de réorganiser automatiquement les flux entrant et sortant (position haut / bas)",
          SlctOutLink:"Permettre de sélectionner tous les flux sortants du/des noeud(s)",
          SlctInLink:"Permettre de sélectionner tous les flux entrants vers le/les noeud(s)",
          IB: "Info bulle : texte formaté en html et affiché avec l'info-bulle du noeud. Cet info-bulle apparait sur espace graphique avec SHIFT + SOURIS sur le noeud"
        },
        apparence:{
          'apparence':'Apparence',
          'Visibilité':'Visibilité',
          'Couleur':'Couleur',
          'CouleurPérenne':'Couleur fixe',
          'Forme':'Forme',
          'Cercle':'Cercle',
          'Rectangle':'Rectangle',
          'TML':'Largeur minimale',
          'TMH':'Hauteur minimale',
          'HideAlone':'Cacher si noeud est intermédiaire',
          'asn':'Appliquer le style aux noeuds',
          'toScale':'Noeud hors échelle',
          'Orientation':'Orientation : ',
          'toScaleBottom':'Vers le bas',
          'toScaleTop':'Vers le haut',
          'toScaleLeft':'Vers la gauche',
          'toScaleRight':'Vers la droite',
          'raw':'Editeur brut',
          tooltips: {
            Visibilité: "Rend le/les noeud(s) selectionné(s) visible(s) ou invisible(s)",
            Couleur: "Choisir la couleur du/des noeud(s) selectionné(s)",
            CouleurPérenne: "Garder la couleur du/des noeud(s) en cas de filtrage",
            Forme: "Choisir une Forme entre rectangle ou cercle pour le/les noeud(s) selectionné(s)",
            TML: "Largeur minimale en pixel du/des noeud(s) selectionné(s)",
            TMH: "Hauteur minimale en pixel du/des noeud(s) selectionné(s)"
          }
        },
        labels:{
          'labels':'Labels',
          'vdb':'Visibilité du label',
          'lb':'Label blanc',
          'pv':'Position verticale',
          'pos':'Position',
          'pos_v':'Position de la valeur',

          'top':'Haut',
          'middle':'Milieu',
          'bottom':'Bas',
          'ph':'Position horizontale',
          'left':'Gauche',
          'right':'Droite',
          'tp':'Taille de police',
          'police':'Style de police',
          'gras':'Gras',
          'maj':'Majuscule',
          'ita':'Italique',
          'cl':'Largeur zone de texte',
          'vdv':'Afficher la valeur',
          tooltips: {
            vdb: "Permet d'afficher ou non le label accolé au(x) noeud(s) sélectionné(s)",
            lb: "Permet d'afficher le texte du label en blanc ou en noir (utile si label positionné sur noeud(s))",
            haut: "Positionner le label au dessus du/des noeud(s) sélectionné(s)",
            Milieu_pv: "Positionner le label au milieu (verticalement) du/des noeud(s) sélectionné(s)",
            Bas: "Positionner le label en dessous du/des noeud(s) sélectionné(s)",
            gauche: "Positionner le label à gauche du/des noeud(s) sélectionné(s)",
            Milieu_ph: "Positionner le label au milieu (horizontalement) du/des noeud(s) sélectionné(s)",
            droite: "Positionner le label à droite du/des noeud(s) sélectionné(s)",
            cl: "Largeur de la zone de texte (en pixel) pour le label du/des noeud(s) sélectionné(s)",
            vdv: "Active l'affichage de la valeur associée au(x) noeud(s) sélectionné(s)",
            haut_val: "Positionner l'affichage de la valeur associée au dessus du/des noeud(s) sélectionné(s)",
            Milieu_pv_val: "Positionner l'affichage de la valeur associée au milieu (verticalement) du/des noeud(s) sélectionné(s)",
            Bas_val: "Positionner l'affichage de la valeur associée en dessous du/des noeud(s) sélectionné(s)",
            gauche_val: "Positionner l'affichage de la valeur associée à gauche du/des noeud(s) sélectionné(s)",
            Milieu_ph_val: "Positionner l'affichage de la valeur associée au milieu (horizontalement) du/des noeud(s) sélectionné(s)",
            droite_val: "Positionner l'affichage de la valeur associée à droite du/des noeud(s) sélectionné(s)",
          }
        },
        icon:{
          'icon':'Icône',
          'si':'Sélectionner l\'icône',
          'couleur':'Couleur',
          'rIN':'Ratio taille icône/noeud',
          'Aucun':'Aucun'
        },
        FO:{
          'FO':'Foreign Object',
          'content':'Contenu',
        },
        tags_node:{
          'tags':'Étiquettes',
          'Appartenance':'Appartenance'
        },
        agre:{
          'Agré':'Agrégations',
          'DC':'Dimension du cube',
          'Parent':'Parent',
          'CLE':'Copier liens enfants'
        },
        PF:{
          'PF':'Flux E/S',
          'PFM':'Organiser flux E/S',
          'FES':'Type de flux',
          'ent':'Entrant',
          'sort':'Sortant',
          'FRN':'Position relative au noeud',
          'gauche':'Gauche',
          'droite':'Droite',
          'ades':'Au-dessus',
          'edes':'En-dessous',
          'lti':'Afficher les couleurs',
          'col':'Appliquer',
          tooltips:{
            ent: "Afficher les flux entrants du/des noeud(s) selectionné(s)",
            sort: "Afficher les flux sortant du/des noeud(s) selectionné(s)",
            droite: "Afficher les flux se situant à droite du/des noeud(s) selectionné(s)",
            gauche: "Afficher les flux se situant à gauche du/des noeud(s) selectionné(s)",
            ades: "Afficher les flux se situant au dessus du/des noeud(s) selectionné(s)",
            edes: "Afficher les flux se situant en dessous du/des noeud(s) selectionné(s)",
            lti: "Affiche les lignes du tableau des flux avec leur couleurs respectives pour mieux les identifier"
          }
        }
      },
      Flux:{
        'pg': 'Paramètres généraux',
        'pdl':'Police des labels',
        'pl': 'Paramètres par flux',
        'src':'Source',
        'trgt':'Cible',
        'if':'Inverser la direction',
        'dzf':'Superposition à l\'affichage',
        'style':'Style',
        'as':'Appliquer le style au(x) flux selectionné(s)',
        'asf':'Appliquer le Style aux flux',
        'IB':'Info-bulle',
        tooltips: {
          src: "Choix du noeud de départ pour le/les flux sélectionné(s)",
          trgt: "Choix du noeud d'arrivée pour le/les flux sélectionné(s)",
          if: "Permet d'inverser les noeuds de départ et d'arrivée pour le/les flux sélectionné(s)",
          up: "Monter d'un cran vers le premier plan",
          upup: "Mettre le/les flux selectionné(s) au premier plan",
          dwn: "Descendre d'un cran vers le dernier plan",
          dwndwn: "Mettre le/les flux sélectionné(s) au dernier plan",
          as: "Permettre d'appliquer un style prédéfini dans le menu préférence au(x) noeud(s) selectionné(s)",
          IB: "Info bulle : texte formaté en HTML et affiché avec l'info-bulle du flux. Cet info-bulle apparait sur espace graphique avec SHIFT + SOURIS sur le flux"
        },
        data:{
          'données':'Données',
          'vpp':'Valeur pour ces paramètres',
          'affichage':'Affichage',
          'toPrecision':'En notation scientifique',
          tooltips: {
            vpp: "Valeur associée au flux sélectionné et, si existant(s), pour le/les tag(s) de flux selectionné(s)",
            toPrecision: "Activer ou non la notation en format scientifique, pour l'affichage de la valeur du flux sur le diagramme de Sankey",
            affichage: "Texte de remplacement de l'affichage de la valeur du flux sur le diagramme de Sankey"
          }
        },
        apparence:{
          'apparence':'Apparence',
          'couleur':'Couleur',
          'grad':'Gradient',
          'hach':'Hachuré',
          'of':'Orientation',
          'pdc':'Position du point central (%)',
          'eep':'Position des centres de courbure (%)',
          'type':'Type',
          'courbe':'Courbe',
          'fleche':'Flèche',
          'recy':'Recyclage',
          'courbure':'Courbure',
          'opacity':'Opacity',
          'arrow_size':'Taille de la flèche',

          tooltips: {
            couleur: 'Choisir la couleur pour le/les flux sélectionné(s)',
            grad: 'Applique un effet de gradient de couleur sur le/les flux sélectionné(s). Le gradient est réalisé entre la couleur du noeud de départ et celle du noeud d\'arrivée',
            hach: 'Applique un effet de hachure sur le/les flux sélectionné(s)',
            of_vv: 'Permet d\'orienter le début du flux verticalement et la fin du flux verticalement',
            of_hh: 'Permet d\'orienter le début du flux horizontalement et la fin du flux horizontalement',
            of_hv: 'Permet d\'orienter le début du flux horizontalement et la fin du flux verticalement',
            of_vh: 'Permet d\'orienter le début du flux verticalement et la fin du flux horizontalement',
            pdc: 'Permet d\'affiner la position du centre du/des flux sélectionné(s). Cette valeur est un ratio (%) relatif au au point de départ du flux.',
            eep: 'Permet d\'affiner les positions des centres de courbure du/des flux sélectionné(s). Cette valeur est un ratio (%) relatif au point central du flux. Ces centres de courbure se positionnent en miroir par rapport au centre du/des flux',
            courbe: 'Représente le/les flux sélectionné(s) sous forme de courbe(s) de Bezier.',
            fleche: 'Représente le/les flux sélectionné(s) avec une pointe de flèche à la fin.',
            recy: 'Représente le/les flux sélectionné(s) sous forme de recyclage, ie. avec un retour vers l\'arrière.',
            courbure: 'Paramétrage du rayon de courbure dans le cas ou le/les flux sélectionné(s) sont sous forme de courbe(s) de Bezier',
            arrow_size:'Modifie la taille de la flêche (largeur entre la fin du flux et le noeud)'

          }
        },
        label:{
          'label':'Label',
          'vdb': 'Visibilité du label',
          'len':'Label en noir',
          'lb':'Label en blanc',
          'lec':'Label en couleur',
          'acf':'Orienter suivant l\'axe du flux',
          'pl':'Positionnement Lateral',
          'po':'Positionnement Orthogonal',
          'milieu': 'Milieu',
          'deb':'Début',
          'fin':'Fin',
          'dessous':'Dessous',
          'dessus':'Dessus',
          'pls':'Positionner le label à la souris',
          'toPrecision':'Afficher la valeur en notation scientifique',
          'NbPrecision':'Nombre de signe significatif',

          tooltips: {
            label: "Permet d'afficher ou non le label (donnée / texte) associé au(x) flux sélectionné(s)",
            len: "Afficher le texte du label en noir, pour le(s) flux sélectionné(s)",
            lb:"Afficher le texte du label en blanc, pour le(s) flux sélectionné(s)",
            lec: "Afficher le texte du label avec la/les même(s) couleur(s) que celle(s) associée(s) au(x) flux sélectionné(s)",
            acf: "Pour le/les flux sélectionné(s), permet d'orienter le texte du label en suivant la forme du flux associé",
            deb: "Pour le/les flux sélectionné(s), permet de positionner le texte du label vers le point de départ du flux",
            milieu_h: "Pour le/les flux sélectionné(s), permet de positionner le texte du label entre le point de départ et le point d'arrivée du flux",
            fin: "Pour le/les flux sélectionné(s), permet de positionner le texte du label vers le point d'arrivée du flux",
            dessous: "Pour le/les flux sélectionné(s), permet de positionner le texte du label en dessous du flux",
            milieu_v: "Pour le/les flux sélectionné(s), permet de positionner le texte du label dans le flux",
            dessus: "Pour le/les flux sélectionné(s), permet de positionner le texte du label au dessus du flux",
            pls: "Active la possibilité de déplacer avec la souris le label du/des flux sélectionné(s)",
            toPrecision: 'Activer ou non la notation en format scientifique, pour l\'affichage de la valeur du flux sur le diagramme de Sankey',
            NbPrecision:'Choisi le nombre de chiffre significatif à afficher quand la valeur est en notation scientifique ',

          }
        },
        'layout':'Disposition',
        'layoutUp':'Envoyer vers l \'avant',
        'layoutTop':'Envoyer à l \'avant',
        'layoutDown':'Envoyer vers l \'arrière',
        'layoutBottom':'Envoyer à l \'arrière',
      },
      LL:{
        'hl':'Hauteur zone de texte',
        'll':'Largeur zone de texte',
        'ft':'Opacité du fond',
        'cfl':'Couleur fond zone de texte',
        'bt':'Bordure transparent',
        'cbl':'Couleur bordure zone de texte',
        'pvt':'Position verticale texte',
        'at':'Alignement texte',
        'labels':'Style police',
        'gras':'Gras',
        'maj':'Majuscule',
        'ita':'Italique',
        'centre':'Centre',
        'textAsHTML':'Zone de texte en HTML',
        'editorRaw':'Editeur brut'

      },
      Banner:{
        'data':'Données',
        'fdf':'Filtrage des flux',
        'fdn':'Filtrage des noeuds',
        'ndd':'Niveaux de détail',
        'ndd_lst':'Groupes d\'étiquettes',
        'ndd_chk':'Appliquer les couleurs associées',
        'sdr':'Type de diagramme',
        'sdd':'Sélection des données',
        'tl':'Téléchargements',
        'rslt':'Téléchargement résultats',
        'p_aff':'Paramètres d\'affichage',
        'p_aff_aff_links':'Paramètres d\'affichage des flux',
        'p_aff_aff_node':'Paramètres d\'affichage des noeuds',
        'p_aff_filtre_links':'Paramètres de filtrage visuel des flux',
        'filtre':'Valeur seuil pour l\'affichage des flux',
        'fl':'Valeur seuil pour l\'affichage des labels',
        'fn':'Flux nuls',
        'visible':'Visible',
        'hlp':'Aide',
        'hlp_1':'Les diagrammes de Sankey',
        'hlp_1_txt_1':'Dans un diagramme de sankey l\'épaisseur d\'une flèche est proportionnelle à la valeur du flux qu\'elle représente.',
        'hlp_1_txt_2':'Le diagramme peut être visualisé avec différents niveaux d\'agrégations en utilisant le sélecteur Niveau de détail',
        'hlp_1_txt_3':'Des filtres peuvent être utilisés pour n\'afficher que des parties du diagramme. Pour cela utiliser les selecteurs',
        'hlp_1_txt_4':'Différents palettes de couleurs peuvent être utiliser pour colorer les noeuds et les flux en utilisant le sélecteur Palette de Couleurs',
        'hlp_1_txt_5':'La structure du diagramme (sans épaisseur de flux) peut être affiché en cochant Structure du diagramme',
        'hlp_1_txt_6':'Le diagramme peut être ajusté à l\'écran en cochant Ajuster à l\'écran',
        'hlp_1_txt_7':'Pour obtenir des informations sur chaque flux, appuyer sur shift et passer la souris sur le flux.',
        'hlp_1_txt_8':'Pour gérer des paramètres sur les éléments visibles du sankey',
        'hlp_1_txt_9':'Menu déroulant pour filtrer les noeuds/flux/données selon leur groupe d\'étiquette associée ou bien pour appliquer des couleurs au diagramme avec la palette de couleurs du groupe d\'étiquette.',
        'tooltipAdjust':'Permet de réajuster la zone de dessin à la taille de l\'écran',
        'tooltipStructure':'Permet d\'afficher la structure du diagramme sans proportion des flux selon leur valeur',
        'tooltipData':'Permet d\'afficher les données du diagramme',
        'tooltipSelection':'Permet de sélectionner ou de déplacer les noeuds',
        'tooltipHelp':'Affiche le dialogue d\'aide',
        'tooltipLiason':'Permet de créer des flux entre deux noeuds existants, depuis un noeud existant ou vers un noeud existant'
      },
      Login:{
        'con':'Connexion',
        'dec':'Deconnexion',
        'con_win':'Se connecter à l\'application',
        'err_appel_serveur':'Une erreur est survenue lors de l\'appel au serveur',
        'err_login':'Erreur, votre e-mail ou mot de passe est incorrect, veuillez vérifier vos informations de connexion et réessayer'
      },
      Register:{
        'reg_win':'Créer un compte',
        'OS+_lic': 'Numéro de Licence OpenSankey+ (Optionnelle)',
        'OS+_link':'Découvrir OpenSankey+',
        'SS_lic': 'Numéro de Licence SankeySuite (Optionnelle)',
        'SS_link':'Découvrir SankeySuite',
        'reg': 'S\'enregistrer'
      },
      UserPages:{
        'to_app':'Retour à l\'application',
        'to_con':'Se connecter',
        'to_reg':'Créer un compte',
        'to_acc':'Mon compte',
        'to_dbd':'Dashboard',
        'id': 'Identifiant',
        'mdp': 'Mot de passe',
        'pnom': 'Prénom',
        'nom': 'Nom',
        'OS+_lic': 'Licence OpenSankey+',
        'SS_lic': 'Licence SankeySuite',
        'update_lic': 'Enregistrer',
        'win_acc_infos': 'Mes informations',
        'win_db_template': 'Modèles proposés',
        'db_desc_template': 'Description du modèle',
        'usr_no_lic': 'Pas de licence enregistrée',
        'usr_lic_validdate': 'Date de validité : ',
        'usr_lic_expdate': 'Expirée depuis le : ',
        'usr_lic_valid': 'Licence valide',
        'usr_lic_invalid': 'Licence non valide',
        'usr_lic_deactivated': 'Licence desactivée',
        'usr_lic_err': 'Erreur numéro licence',
        'err_get_user_infos':'Erreur lors de l\'accès aux données de l\'utilisateur',
        'err_get_OS+_infos': 'Erreur lors de l\'accès au serveur de licences OpenSankey+',
        'err_get_SS_infos': 'Erreur lors de l\'accès au serveur de licences SankeySuite'
      },
      view:{
        'select':'Sélection Vue',
        'actual':'Sankey maître',
        'name':'Nom',
        'delete':'Supprimer',
        'copy':'Cloner',
        'import':'Importer',
        'export':'Exporter',
        'applyDisplayFromView':'Appliquer la mise en page d\'une autre vue ',
        'ns':'Vue non enregistrée',
        'warn_ns':'Vous êtes sur le point de changer de vue avant d\'avoir sauvegardé la vue actuelle, voulez-vous sauvegarder les changements avant de changer de vue ?',
        'dont_save':'Non',
        'save':'Oui',
        'exportAll':'Exporter toutes les vues',
        'importMultiple':'Importer plusieurs vues',

      },
      welcome:{
        'welcome':'Bienvenue sur l\'application web OpenSankey',
        'read_me':'Lisez moi',
        'intro':'Introduction',
        'rc':'Raccourcis clavier',
        'licence':'Licences',
        'news':'Nouveautés',
        'exemple1':'Exemple d\'un diagramme de sankey comme des dégradés comme couleur de flux  (fonctionnalité d\'Opensankey+) ',
        'exemple2':'Exemple d\'un diagramme de sankey pouvant être réalisé avec Opensankey',
        1:'Bouton de sélection du mode de la souris, il existe 2 modes : un mode permettant de sélectionner les noeuds et flux pour pouvoir les déplacer, puis un mode permettant de créer des liens et noeuds aux cliques de la souris',
        2:'Boutons permettant de filtrer la visibilité ou couleurs des noeuds et flux en fonction des groupes auxquels ils sont associés',
        3:'Bouton permettant de filtrer les noeuds en fonction de leur niveau d\'agrégation',
        4:'Bouton permettant de filtrer la visibilité des flux en fonction de leurs valeurs, ce bouton permet aussi de modifier l\'échelle du diagramme (l\'épaisseur des flux)',
        5:'Bouton permettant de réajuster la taille de la zone de dessin pour que tous les éléments soient visibles',
        6:'Bouton permettant d\'afficher le diagramme sans prendre en compte la valeur des flux',
        7:'Bouton permettant d\'afficher de l\'aide supplémentaire',
        8:'Menu de navigation permettant d\'ouvrir, enregistrer, éditer des sankeys ',
        9:'Bouton permettant de se connecter avec un compte opensankey et activer des modules supplémentaires',
        10:'Bouton permettant d\'ouvrir le menu de configuration qui permet d\'éditer les éléments du diagramme de sankey',
        'view':'Boutons permettant de naviguer entre les différentes vues du diagramme',
        'excel':'Bouton permettant de télécharger les données au format Excel',
        'news_content': {
          230803: {
            'main_title': '03 Août 2023 : Nouvelles fonctionnalités',
            'main_content': 'Pleins de nouvelles fonctionnalités pour faciliter la manipulation des diagrammes de Sankey',
            'sub_title_1': 'Ajout d\'un clic droit avec options d\'édition',
            'sub_content_1': 'Désormais, un certain nombre d\'options sur les noeuds, flux et zone de dessin sont accessible par clic droit sur les éléments concernés.',
            'sub_title_2': 'Ajout d\'un cadre de selection multiple',
            'sub_content_2': 'La selection multiple de noeuds peut maintenant se faire avec cadre de sélection.',
            'sub_title_3': 'Possibilité d\'agrandir la zone de dessin',
            'sub_content_3': 'La zone de dessin devient extensible dans toutes les directions en glissant les noeuds / flux / zones de texte / légende dans la direction choisie',
            'image1': 'clic droit noeud.PNG',
            'image2': 'clic droit flux.PNG',
            'image3': 'clic droit fond.PNG',
            'image4': 'Zone de selection.PNG'
          }
        }
      },
      'useTemplate':'Utiliser ce modèle',
      'dl':'Télécharger (excel)',
      'useTutoJSON':'Ouvrir ce fichier',
      'useTutoExcel':'Ouvrir ce fichier (Excel)',
      'menuTuto':'Ouvrir menu tutoriel',
      'DisplayWelcome':'Afficher bienvenue',
      'dontSeeAgain':'Ne plus montrer',
      'elements_sankey+_blocked':'Elements du diagrame bloqués (OpenSankey+)',
      'elements_mfa_blocked':'Elements du diagrame bloqués (MFASankey+)',
      'elements_sankey+_blocked_long':'Certains éléments du Sankey ne sont pas visible car ils proviennent de OpenSankey+ et votre compte ne possède pas ce module',
      'elements_mfa_blocked_long':'Certains éléments du Sankey ne sont pas visible car ils proviennent de MFASankey et votre compte ne possède pas ce module',
      'scale':'Échelle',
      'desire_to_know_more':'En savoir +',
      'legal':'Mention légales',
      'tdr':'Tous droits réservées',
      'fullscreen':'Activer le mode pleine écran',
      'exitFullscreen':'Quitter le mode pleine écran',

    }
  }
}

i18next
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    // lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18next